import React, {useState} from "react";
import {Form, Col, Button, ListGroup, Row} from "react-bootstrap";
import pagesActions from "../../pages/pagesActions";
import Loader from "../Loader";
import utils from "../../helpers/utils";
import {Actions} from "../../../client/Actions";
import Tippy from "@tippyjs/react";
import ImageTooltipContent from "../tooltip/ImageTooltipContent";
import TooltipImage from "../tooltip/TooltipImage";
import {useTranslation} from "react-i18next";


const FormInputFile = ({
                           titleText,
                           labelText,
                           idName,
                           path,
                           requestParameterName,
                           setImagesParentStore,
                           imagesParentStore,
                           inputSize,
                           btnSize,
                           withoutList,
                           disabled
                       }) => {

    const {t} = useTranslation();

    const default_label_txt = t("forms.choose_file");

    const [store, setStore] = useState(null);
    const [labelTxt, setLabelTxt] = useState(labelText ? labelText : default_label_txt);
    const [isBtnDisabled, setIsBtnDisabled] = useState(true);
    // loader
    const [loader, setLoader] = useState(false);

    const validateAndUpload = event => {
        setLoader(true);
        const newformData = new FormData();
        newformData.append(requestParameterName, store);
        newformData.append("description", null);
        Actions.post("file", newformData, callback);
    };


    const onImageChange = event => {
        if (event.target.files.length > 0) {
            setStore(event.target.files[0]);
            setLabelTxt(event.target.files[0].name);
            // activate btn
            setIsBtnDisabled(false);
        } else {
            setLabelTxt(default_label_txt);
            setStore(null);
            setIsBtnDisabled(true);
        }
    };

    const onImageInputClick = event => {
        event.target.value = null;
        setStore(null);
        setIsBtnDisabled(true);
    };

    const callback = (data) => {

        if (withoutList) {
            setImagesParentStore(old => [...old, {
                id: data.id,
                fileName: data.fileName,
                filePath: data.filePath,
                description: data.description,
            }])
        } else {
            imagesParentStore.push({
                id: data.id,
                fileName: data.fileName,
                filePath: data.filePath,
                description: data.description,

            });
            setImagesParentStore(imagesParentStore);
        }


        // reset
        setStore(null);
        setLabelTxt(default_label_txt);
        setIsBtnDisabled(true);


        setLoader(false);
    };

    const handleDeleteImage = (id) => {
        callbackDeleteToolSetImage(id)
        // Actions.delete("file/" + id, {}, () => callbackDeleteToolSetImage(id));
    };

    const callbackDeleteToolSetImage = (id) => {
        const items = imagesParentStore.filter(item_image => item_image.id !== id);
        setImagesParentStore(items);
    };

    return (
        <>
            <Loader loader={loader} setLoader={setLoader}/>
            <Form.Label><strong>{titleText}</strong></Form.Label>
            {!withoutList &&
                <ListGroup variant="flush">
                    {imagesParentStore.map((el) =>
                        <ListGroup.Item key={el.id}>
                            <Row>
                                <Col md={disabled ? 12 : 10}>
                                    <TooltipImage
                                        className={"file_name_text_input_form"}
                                        fileName={el.fileName}
                                        filePath={el.filePath}>
                                        {el.fileName}
                                    </TooltipImage>
                                </Col>
                                <Col md={disabled ? 0 : 2}>
                                    {!disabled &&
                                        <i className="fas fa-trash-alt delete_btn_image cursor-pointer"
                                           onClick={e => handleDeleteImage(el.id)}/>}
                                </Col>
                            </Row>
                        </ListGroup.Item>
                    )}
                    {imagesParentStore.length === 0 && disabled ? t("common.no_attachments") : ""}
                </ListGroup>
            }
            {!disabled ?
                <Form.Row className="mt-3">
                    <Col md={inputSize ? inputSize : 9}>
                        <Form.Group>
                            <Form.File id={idName} label={labelTxt} land="pl" custom onChange={onImageChange}
                                       disabled={disabled}
                                       onClick={onImageInputClick}/>
                        </Form.Group>
                    </Col>
                    <Col md={btnSize ? btnSize : 3}>
                        <Form.Group>

                            <Button variant="primary" className={"full_content_btn upload_input_" + idName}
                                    disabled={isBtnDisabled}
                                    onClick={validateAndUpload}> {t("forms.upload_file")} </Button>
                        </Form.Group>
                    </Col>
                </Form.Row> : ""}
        </>
    );
};

export default FormInputFile;